<template>
  <div class="sim">
    <ul>
      <div class="form-row">
        <div class="form-row form-group form-inline">
          <B><label>選手名 （<a @click="RandNameSet();"><font color="#42b983">ランダム</font></a>）</label></B>
          <input type="text" autocomplete="on" list="suggss" v-model="playername"
          placeholder="選手名を入力" @change="setName(playername);" />
          <datalist id="suggss">
          <select name="sug">
            <option v-for="n in $store.state.suggestionList" :key="n" @click="setName(playername);">{{n}}</option>
          </select>
          </datalist>
          &nbsp;&nbsp;<button class="btn btn-primary" @click="setName(playername);">成績代入</button>
        </div>
      </div>
      <br>
      <B><label>成績入力</label></B>
      <div id="contents">
        <div class="tab_box">
          <ul class="tab_list">
            <li v-on:click="TabChange('N')" v-bind:class="{'active': Tabselect === 'N'}">通常</li>
            <li  v-if="Yearcheck==='y'" v-on:click="TabChange('O')" v-bind:class="{'active': Tabselect === 'O'}">オリジナル</li>
            <!-- <li v-if="Yearcheck==='y'" v-on:click="TabChange('P')" v-bind:class="{'active': Tabselect === 'P'}">成績予測テスト</li> -->
          </ul>

          <ul class="article" v-if="Tabselect!=='P'">
            <li>
            <div class="form-row col-md-20">
              <div class="col-md-3 form-row form-group form-inline"
              v-for="(rec, i) in InputProfile" :key="i">
                <label class="col-sm-3" :for="rec">{{RecordName(rec)}}</label>
                <input v-if="rec !== 'hand'" class="col-sm-9 form-control" type="text"
                :value="record[rec]" @change="updateRecord($event.target.value, rec)" />
                <div v-if="rec === 'hand'">
                  <!-- multiple を入れると複数選択可能-->
                  <v-select
                    label="hand"
                    @input="updateRecord($event, 'hand')"
                    :options="InputHandList"
                    :value="$store.state.record['hand']"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="form-row col-md-20">
              <div class="col-md-2 form-row form-group form-inline"
              v-for="(rec, i) in InputRecordList" :key="i">
                <label class="col-sm-3" :for="rec">{{RecordName(rec)}}</label>
                <input class="col-sm-9 form-control" type="text"
                :value="record[rec]" @change="updateRecord($event.target.value, rec)" />
              </div>
              <div v-if="PBcheck==='b'" class="col-md-2 form-row form-group form-inline">
                <label class="col-sm-3" for="AVG">打率</label>{{printAVG(setAVG, 3)}}
              </div>
              <div v-if="PBcheck==='p'" class="col-md-2 form-row form-group form-inline">
                <label class="col-sm-3" for="ERA">防御率</label>{{printAVG(setERA, 2)}}
              </div>
            </div>
            <div v-if="PBcheck==='b' && PosNumFlag === false">
              <label>位置（計算対象<input type="checkbox" v-model="targetPos" >）</label>
              <div class="form-row">
                <div v-for="(pos, i) in selectedPoss" :key="i">
                  <input type="checkbox" :value="selectedPoss[i]"
                  :key="i" :checked="selectedPoss[i]"
                  @change="updatePos(i)">
                  <label>{{PosList[i]}}&nbsp;&nbsp;&nbsp;</label>
                </div>
              </div>
            </div>

            <div  v-if="PBcheck==='b' && PosNumFlag" class="form-row col-md-20">
              <div class="col-md-2 form-row form-group form-inline"
              v-for="(rec, index) in PosList" :key="index">
                <label class="col-sm-3" :for="rec">{{rec}}</label>
                <input class="col-sm-9 form-control" type="text"
                :value="inputedPoss[rec]" @change="updatePosNum($event.target.value, rec)" />
              </div>
            </div>

            </li>
          </ul>
        </div>
      </div>
      <input type="checkbox" :value="targetMatchName" :checked="targetMatchName"
      @change="updateCheck('targetMatchName')">
      <label><a @click="updateCheck('targetMatchName')">同名選手を検索対象から外す</a></label>
    </ul>
  </div>
</template>

<script>
import Mixin from '../../mixins/utility'
export default {
  name: 'NameInput',
  mixins: [Mixin],
  methods: {
    updateCheck (keyname) {
      this.$store.commit('updateValue', {vals: this.$store.state[keyname] === false, keyname: keyname})
    },
    updateRecord (vals, keyname) {
      let r = Object.assign({}, this.record)
      r[keyname] = vals
      this.$store.commit('updateValue', {vals: r, keyname: 'record'})
      console.log(this.record)
    },
    updatePos (keyname) {
      let r = this.selectedPoss
      r[keyname] = (r[keyname] === false)
      this.$store.commit('updateValue', {vals: r, keyname: 'selectedPoss'})
    },
    updatePosNum (value, keyname) {
      let r = this.inputedPoss
      r[keyname] = value
      this.$store.commit('updateValue', {vals: r, keyname: 'inputedPoss'})
    },
    TabChange: function (num) {
      if (this.Tabselect !== num) {
        const pnf = this.PosNumFlag
        this.$store.dispatch('setValue', {vals: num, keyname: 'Tabselect'})
        if (pnf !== this.PosNumFlag) {
          if (this.PosNumFlag) {
            const posbox = {
              '投': '',
              '捕': '',
              '一': '',
              '二': '',
              '三': '',
              '遊': '',
              '外': '',
              '指': ''
            }
            this.$store.dispatch('setValue', {vals: posbox, keyname: 'inputedPoss'})
          } else {
            this.$store.dispatch('setValue', {vals: Array(this.PosList.length).fill(false), keyname: 'selectedPoss'})
          }
        }
      }
    }
  },
  computed: {
    playername: {
      get () {
        return this.$store.state.playername
      },
      set (value) {
        this.$store.commit('updateValue', {vals: value, keyname: 'playername'})
      }
    }
  }
}
</script>
<style scoped>
li {
  list-style: none;
}
.tab_list {
  overflow: hidden;
}
.tab_list li {
  float: left;
  padding: 10px 20px;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: .3s;
}
.tab_list li:not(:first-child) {
  border-left: none;
}
.tab_list li.active {
  background-color: #000;
  border-color: #000;
  color: #fff;
  cursor: auto;
}
.article{
  overflow: hidden;
  margin-top: -1px;
}
.article li {
  padding:20px;
  border: 1px solid #ccc;
  padding-bottom: 0px;
}
</style>
<!-- npm audit fix -->



// WEBPACK FOOTER //
// src/components/SimilarityParts/NameInput.vue